class Identity {
    ldContext: { [key: string]: "multi" | Record<string, string | boolean> } = {
        kind: "multi",
        user: { kind: "user", anonymous: true }
    };
    logRocket: { uid: string; traits: Record<string, string> } = { uid: "", traits: {} };

    #shareGateAccountId?: string;
    #microsoftUserId?: string;
    #microsoftTenantId?: string;
    #workspaceId?: string;

    get shareGateIdentification() {
        return {
            shareGateAccountId: this.#shareGateAccountId ?? "N/A",
            microsoftUserId: this.#microsoftUserId ?? "N/A",
            microsoftTenantId: this.#microsoftTenantId ?? "N/A",
            workspaceId: this.#workspaceId ?? "N/A"
        };
    }

    setFeatureFlagKey(featureFlagKey: string) {
        this.ldContext.featureFlagKey = { key: featureFlagKey };
    }

    setSgUserId(shareGateAccountId: string) {
        this.ldContext.user = { key: shareGateAccountId };
        this.logRocket.uid = shareGateAccountId;
        this.#shareGateAccountId = shareGateAccountId;
    }

    setWorkspaceId(workspaceId: string) {
        this.ldContext.workspace = { key: workspaceId };
        this.#workspaceId = workspaceId;
    }

    setTenantId(tenantId: string) {
        this.ldContext.tenant = { key: tenantId };
        this.#microsoftTenantId = tenantId;
    }

    clearTenantId() {
        delete this.ldContext["tenant"];
        this.#microsoftTenantId = undefined;
    }

    setMicrosoftId(microsoftUserId: string) {
        this.#microsoftUserId = microsoftUserId;
    }

    setRequesterMicrosoftUserId(requesterMicrosoftUserId: string) {
        this.ldContext.user = { key: requesterMicrosoftUserId };
        this.logRocket.uid = requesterMicrosoftUserId;
        this.logRocket.traits["Requester Microsoft User Id"] = requesterMicrosoftUserId;
    }

    setReviewerUserId(reviewerUserId: string) {
        this.ldContext.user = { key: reviewerUserId };
        this.logRocket.uid = reviewerUserId;
        this.logRocket.traits["Reviewer User Id"] = reviewerUserId;
    }

    setShareRecipientUserId(shareRecipientUserId: string) {
        this.ldContext.user = { key: shareRecipientUserId };
        this.logRocket.uid = shareRecipientUserId;
        this.logRocket.traits["Share Recipient User Id"] = shareRecipientUserId;
    }
}

export const identity = new Identity();
